import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { BrandMarquee } from "@/components/BrandMarquee";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/data";

const CHAPTERS = [
  { n: "01", title: "It started with a messy move.", text: "Our founders lived the cardboard nightmare — collapsing boxes, endless tape, and a mountain of waste on moving day. There had to be a smarter way to move a family across town." },
  { n: "02", title: "A locally owned idea.", text: "Color Crate Moving was born right here in Southwest Iowa: a homegrown business built to make moving cleaner, easier, and far less stressful for our neighbors." },
  { n: "03", title: "Pack by color, move with ease.", text: "Our color-coded system means every room has its own crate. No mislabeled boxes, no guessing — just grab, stack, and go. Reusable totes that are kinder to your back and the planet." },
  { n: "04", title: "Here for your next chapter.", text: "Whether you're a first-time buyer, a downsizing senior, a busy family, or a growing business — we deliver, you pack, and we pick up. Moving, finally made simple." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        overline="Our Story"
        title="A locally owned business on a mission to fix moving."
        subtitle="We're Color Crate Moving — and we believe your move should be the exciting part, not the exhausting part."
      />

      <section className="mx-auto max-w-7xl px-6 md:px-12 pb-16">
        <Reveal>
          <div className="rounded-2xl overflow-hidden border border-white/10">
            <img src={IMAGES.familyMoving} alt="A family moving with Color Crate totes" className="w-full h-[280px] md:h-[460px] object-cover" />
          </div>
        </Reveal>
      </section>

      <section className="mx-auto max-w-5xl px-6 md:px-12 pb-24 md:pb-32">
        <div className="space-y-16 md:space-y-24">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div className="grid md:grid-cols-[140px_1fr] gap-6 md:gap-12 items-start">
                <span className="font-heading font-black text-6xl md:text-7xl text-stroke-white leading-none">{c.n}</span>
                <div>
                  <h2 className="font-heading font-bold text-3xl md:text-4xl text-white tracking-tight">{c.title}</h2>
                  <p className="mt-4 text-white/60 text-lg leading-relaxed">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <BrandMarquee />

      <section className="py-24 mx-auto max-w-7xl px-6 md:px-12 text-center">
        <Reveal>
          <h2 className="font-heading font-black text-4xl md:text-6xl text-white tracking-tighter">Let's make your next move the easy one.</h2>
          <Link to="/reserve" className="mt-8 inline-flex items-center gap-2 rounded-full bg-crate-yellow text-crate-black font-bold px-8 py-4 hover:bg-white transition-colors" data-testid="about-reserve-btn">
            Reserve Your Totes <ArrowRight className="h-5 w-5" />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
